import React, { useState, useEffect } from "react";
import servicesData from "../../../assets/data/servicesData.json"; // Adjust the import path as necessary

function MainWid({ serviceLink }) {
  const [serviceDetails, setServiceDetails] = useState(null);

  useEffect(() => {
    // Using 'links' to match the service, according to your JSON data structure
    const service = servicesData.find((s) => s.links === serviceLink);
    setServiceDetails(service);
  }, [serviceLink]);

  if (!serviceDetails) {
    return <div>Loading service details...</div>;
  }

  // Simplifying image path handling assuming images are in the public directory
  const getImagePath = (imagePath) =>
    `${process.env.PUBLIC_URL}/assets/img/${imagePath}`;

  return (
    <section className="services-details-area pt-120 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="services-details-wrap">
              <div className="services-details-thumb">
                <img
                  src={getImagePath(serviceDetails.image)}
                  alt={serviceDetails.title}
                />
              </div>
              <div className="services-details-content">
                <h2 className="title">{serviceDetails.title}</h2>
                <p>{serviceDetails.description}</p>
                {serviceDetails.detailedDescription && (
                  <p>{serviceDetails.detailedDescription}</p>
                )}
                {serviceDetails.processSteps && (
                  <div className="services-process-wrap">
                    <h3>INFORMACE O SLUŽBĚ</h3>
                    {serviceDetails.processSteps.map((step, index) => (
                      <div key={index}>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                        <img src={getImagePath(step.image)} alt={step.title} />
                      </div>
                    ))}
                  </div>
                )}
                {serviceDetails.benefits && (
                  <div className="service-benefits-wrap">
                    <h3>VÝHODY A ZPRACOVÁNÍ</h3>
                    <ul>
                      {serviceDetails.benefits.map((benefit, index) => (
                        <li key={index}>{benefit}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6">
            <aside className="services-sidebar sticky">
              <div className="services-widget">
                <h4 className="widget-title">Všechny služby</h4>
                <div className="our-services-list">
                  <ul className="list-wrap">
                    {servicesData.map((service, index) => (
                      <li key={index}>
                        <a href={`/services/${service.links}`}>
                          {service.title}
                          <i className="fas fa-arrow-right"></i>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainWid;
